import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import DemoBanner from './components/DemoBanner';
import Dashboard from './pages/Dashboard';
import Bookings from './pages/Bookings';
import Ledger from './pages/Ledger';
import Accounting from './pages/Accounting';
import Properties from './pages/Properties';
import Emails from './pages/Emails';
import Templates from './pages/Templates';
import SitePosts from './pages/SitePosts';
import Settings from './pages/Settings';
import Login from './pages/Login';
import Register from './pages/Register';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem('token');
    if (token) {
      setIsAuthenticated(true);
    }
    setLoading(false);
  }, []);

  if (loading) {
    return <div className="loading-spinner"><div className="spinner-border"></div></div>;
  }

  return (
    <Router>
      <DemoBanner />
      {isAuthenticated ? (
        <div className="app-shell">
          <Sidebar />
          <div className="app-main">
            <Navbar setIsAuthenticated={setIsAuthenticated} />
            <main className="main-content">
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/bookings" element={<Bookings />} />
                <Route path="/ledger" element={<Ledger />} />
                <Route path="/accounting" element={<Accounting />} />
                <Route path="/properties" element={<Properties />} />
                <Route path="/emails" element={<Emails />} />
                <Route path="/templates" element={<Templates />} />
                <Route path="/site-posts" element={<SitePosts />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </main>
          </div>
        </div>
      ) : (
        <Routes>
          <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
          <Route path="/register" element={<Register />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      )}
    </Router>
  );
}

export default App;
